import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClientNameService } from '@sharedModule/services/clientName/client-name.service';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent implements OnInit {
  public router = inject(Router);
  public clientName= inject(ClientNameService).clientName();

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate(['/clientName/dashboard/publication']);      
    }, 1000); 
  
  }
}
